import endpoints from "hooks/api/endpoints";
import useApiGet, { UseApiGetOptions } from "hooks/api/useApiGet";
import { SessionDto } from "types/SessionDto";

export default function useGetSession(options?: UseApiGetOptions) {
  const { result, ...rest } = useApiGet<SessionDto>(
    endpoints.getSession(),
    options,
  );

  return { session: result, ...rest };
}
